import React from "react";

function MailSvgBlog() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="14"
      fill="none"
      viewBox="0 0 18 14"
      className="relative -right-2"
    >
      <path
        stroke="#6B7280"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1.5 3.667L8.075 8.05a1.667 1.667 0 001.85 0L16.5 3.667M3.167 12.833h11.666a1.666 1.666 0 001.667-1.666V2.833a1.667 1.667 0 00-1.667-1.666H3.167A1.667 1.667 0 001.5 2.833v8.334a1.666 1.666 0 001.667 1.666z"
      ></path>
    </svg>
  );
}

export default MailSvgBlog;
